import { Allergen, DietaryRestriction } from '@sg/graphql-schema';

import { type AllergenOrDietaryRestriction } from '../../../utils/dietary-preferences';
import {
  type DietaryPreferencesTypes,
  INITIAL_ALLERGENS,
  INITIAL_DIETARY_PREFERENCES,
} from '../setup';
import { mergeKnownProperties } from './merge-known-properties';

// ─────────────────────────────────────────────────────────────────────────────

export function mergeRemoteAllergens(remoteAllergens: Allergen[] | readonly Allergen[]) {
  const preferences = [...remoteAllergens].reduce<Preferences>(addPreference, {});

  return mergeKnownProperties(INITIAL_ALLERGENS, preferences) as DietaryPreferencesTypes;
}

export function mergeRemoteDietaryRestrictions(
  remotePreferences: DietaryRestriction[] | readonly DietaryRestriction[],
) {
  const preferences = [...remotePreferences].reduce<Preferences>(addPreference, {});

  return mergeKnownProperties(INITIAL_DIETARY_PREFERENCES, preferences) as DietaryPreferencesTypes;
}

// ─────────────────────────────────────────────────────────────────────────────

function addPreference(preferences: Preferences, preference: AllergenOrDietaryRestriction) {
  return { ...preferences, [preference]: true };
}

type Preferences = Partial<DietaryPreferencesTypes>;
